import React from 'react';

import { KebabHorizontalIcon } from '@primer/octicons-react';

import BasicDropdown from '../BasicDropdown/BasicDropdown';

export const InvisibleActionButton = ({ actionListOnSelect, actionListArray }) => <BasicDropdown
  direction="top-left"
  dropdownLabel={null}
  iconFill="brand"
  iconSize={12}
  icon={KebabHorizontalIcon}
  values={actionListArray}
  onValueSelected={actionListOnSelect}
  hideBorder
  hideCaret
/>;
